import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'

export default function Images() {
  return (
    <div className="pb-4 bg-black">
      <div className="images-grid max-w-[1700px] w-[95%] text-center mx-auto">
        <div className="images-grid--a">
          <StaticImage src="../../../images/gallery/image-1.png" alt="" />
        </div>
        <div className="images-grid--b">
          <StaticImage src="../../../images/gallery/image-2.png" alt="" />
        </div>
        <div className="images-grid--c">
          <StaticImage src="../../../images/gallery/image-3.png" alt="" />
        </div>
        <div className="images-grid--d">
          <StaticImage src="../../../images/gallery/image-4.png" alt="" />
        </div>
      </div>
    </div>
  )
}
